import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getV2UsersMeOffHoursSchedulesSelector =
  cloudChiprApi.endpoints.getV2UsersMeOffHoursSchedules.select({});
